module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"notice_bar":{"back_message":{"AT":"Back to the austrian version.","CH":"Back to the swiss version.","DE":"Back to the german version."},"usage_message":{"AT":"You are currently using the austrian version of the Website.","CH":"You are currently using the swiss version of the Website.","DE":"You are currently using the german version of the Website."}}}}}}')
  delete Component.options._Ctor
}
